export enum EProductTemplateCreationEventStep {
  PRODUCT_CREATION = 'product_creation',
  PRODUCT_EXPANSION = 'product_expansion',
  STANDALONE_TEMPLATE = 'standalone_template',
}
